import React from 'react';

class SignUpForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {value: ''};

    this.handleChange = this.handleChange.bind(this);
    // this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    this.setState({value: event.target.value});
  }


  render() {
    return (

      <form action="https://whofolio.us17.list-manage.com/subscribe/post" method="POST">
        <input type="hidden" name="u" value="33be81030d42a4d18bf27294a" />
        <input type="hidden" name="id" value="cf70c5a6cb" />
        <input type="email" placeholder="email" name="MERGE0" value={this.state.value} onChange={this.handleChange} />
        <input type="submit" value="Hook me up!" />
      </form>
    );
  }
}

export default SignUpForm;



// WEBPACK FOOTER //
// ./src/assets/components/signUpForm.js